import { Guid } from "client_legacy/ndaw/guid";
import { environmentHttpClient } from "client/Api/httpClient";
import {
	DocumentItemViewModel,
	DocumentsRecycleBinItem,
	ListLocationModel
} from "client/Api/Documents/SharePoint/common";

const controllerRelativeUrl: string = "Documents/SharePoint/RecycleBin";

export function getRecycleBinItems(
	location: ListLocationModel,
	signal?: AbortSignal
): Promise<DocumentsRecycleBinItem[]> {
	return environmentHttpClient.post<DocumentsRecycleBinItem[]>(
		controllerRelativeUrl + "/GetItems",
		location,
		{ signal }
	);
}

export type DeleteRecycleBinItemsModel = {
	location: ListLocationModel;
	deletedItems: readonly Guid[];
};

export function deleteRecycledItems(model: DeleteRecycleBinItemsModel): Promise<void> {
	return environmentHttpClient.post<void>(
		controllerRelativeUrl + "/DeleteItems",
		model
	);
}

export type RecoveryProblem = {
	recycleBinId: Guid;
	reason: "NameAlreadyExist" | "Unknown";
};

export type RestoredDocumentModel = {
	recycleBinId: Guid;
	document: DocumentItemViewModel;
};

export type RecoverFailedResponse = {
	recoveredDocuments: RestoredDocumentModel[];
	problemDocuments: RecoveryProblem[];
};

export type RecoverRecycleBinItemsModel = {
	location: ListLocationModel;
	recycleBinIds: readonly Guid[];
};

export function recoverRecycledItems(model: RecoverRecycleBinItemsModel): Promise<RestoredDocumentModel[]> {
	return environmentHttpClient.post<RestoredDocumentModel[]>(
		controllerRelativeUrl + "/RecoverItems",
		model
	);
}
